import { Link, useLocation } from 'react-router-dom';
import { BookOpen, Heart, DollarSign, TrendingUp, MessageCircle, Home } from 'lucide-react';

const navItems = [
  { path: '/home', icon: Home, label: 'Home' },
  { path: '/bible', icon: BookOpen, label: 'Word' },
  { path: '/chat', icon: MessageCircle, label: 'Pray' },
  { path: '/donate', icon: DollarSign, label: 'Give' },
  { path: '/progress', icon: TrendingUp, label: 'Impact' },
];

export const BottomNav = () => {
  const location = useLocation();
  
  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-lg border-t border-gray-100 py-2 px-4 z-40 shadow-lg"
      data-testid="bottom-navigation"
    >
      <div className="max-w-lg mx-auto flex justify-around items-center">
        {navItems.map(({ path, icon: Icon, label }) => {
          const isActive = location.pathname === path;
          return (
            <Link
              key={path}
              to={path}
              data-testid={`nav-${label.toLowerCase()}`}
              className={`flex flex-col items-center gap-1 px-4 py-2 rounded-2xl transition-all duration-300 min-w-[60px] ${
                isActive 
                  ? 'text-blue-500' 
                  : 'text-gray-400 hover:text-gray-600'
              }`}
            >
              <div className={`p-2 rounded-xl transition-all duration-300 ${
                isActive ? 'bg-blue-50' : ''
              }`}>
                <Icon 
                  className={`w-6 h-6 transition-transform duration-300 ${
                    isActive ? 'scale-110' : ''
                  }`} 
                  strokeWidth={isActive ? 2.5 : 2}
                />
              </div>
              <span className={`text-xs font-semibold ${isActive ? 'text-blue-500' : 'text-gray-500'}`}>
                {label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
